var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 102",
    style: {
      enableBackground: "new 0 0 103 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{display:inline;clip-path:url(#SVGID_00000134966840440519254690000000151300424606161854_);}\r\n\t.st3{fill:#E86E7B;}\r\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 0,
    width: 102,
    height: 102
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150824256401866487820000004179232501889175486_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      clipPath: "url(#SVGID_00000150824256401866487820000004179232501889175486_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.2,93.5h-85c-1.1,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.9-1.2-3v-85c0-1.1-0.4-2.2-1.2-3C7,0.4,5.9,0,4.8,0 s-2.2,0.4-3,1.2C0.9,2,0.5,3.1,0.5,4.2v85c0,3.4,1.3,6.6,3.7,9c2.4,2.4,5.6,3.7,9,3.7h85c1.1,0,2.2-0.4,3-1.2 c0.8-0.8,1.2-1.9,1.2-3s-0.4-2.2-1.2-3C100.5,93.9,99.4,93.5,98.2,93.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 c-1.1,0-2.2,0.4-3,1.2S60,49.9,60,51v29.8c0,1.1,0.4,2.2,1.2,3C62,84.6,63.1,85,64.3,85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2s-2.2,0.4-3,1.2 c-0.8,0.8-1.2,1.9-1.2,3v29.8c0,1.1,0.4,2.2,1.2,3C28,84.6,29.1,85,30.2,85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C79,84.6,80.1,85,81.2,85z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 c-1.1,0-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C45,84.6,46.1,85,47.2,85z"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M6.6,95.6L13,72.4C9.1,65.7,7,58,7,50.1C7,25.5,27.1,5.5,51.7,5.5c11.9,0,23.2,4.7,31.6,13.1 c8.4,8.4,13.1,19.6,13.1,31.6c0,24.6-20.1,44.6-44.7,44.6c-7.5,0-14.8-1.9-21.4-5.4L6.6,95.6z M31.4,81.3c6.3,3.8,12.3,6,20.2,6 c20.5,0,37.1-16.6,37.1-37.1C88.8,29.6,72.2,13,51.7,13S14.6,29.6,14.6,50.1c0,8.4,2.4,14.6,6.5,21.2L17.3,85L31.4,81.3z M74.2,60.8 c-0.3-0.5-1-0.8-2.1-1.3c-1.1-0.6-6.6-3.3-7.6-3.6c-1-0.3-1.8-0.5-2.5,0.6c-0.7,1.1-2.9,3.6-3.5,4.4c-0.6,0.8-1.3,0.8-2.4,0.3 c-1.1-0.6-4.7-1.7-9-5.5c-3.3-3-5.6-6.6-6.2-7.7c-0.7-1.1-0.1-1.7,0.5-2.3c0.5-0.5,1.1-1.3,1.7-2c0.6-0.6,0.8-1.1,1.1-1.8 c0.4-0.8,0.2-1.4-0.1-2c-0.3-0.6-2.5-6.1-3.5-8.3c-0.9-2.2-1.8-1.9-2.5-1.9l-2.1,0c-0.8,0-2,0.3-3,1.4c-1,1.1-3.9,3.8-3.9,9.3 s4,10.8,4.5,11.5c0.6,0.8,7.9,12,19.1,16.9c2.7,1.2,4.7,1.8,6.3,2.4c2.7,0.8,5.1,0.7,7,0.5c2.2-0.3,6.6-2.7,7.5-5.3 C74.5,63.5,74.5,61.2,74.2,60.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.d5f8a66beb93a5a8ff9869de24e15942.svg";
export { ForwardRef as ReactComponent };